// PlannerSearchHistory Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PlannerSearchHistory extends Component {
  static get propTypes () {
    return {
      histories: PropTypes.array,
      onClose: PropTypes.func,
      onSelectHistory: PropTypes.func,
      onClearHistory: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      histories: [],
      onClose: null,
      onSelectHistory: null,
      onClearHistory: null
    }
  }

  render () {
    const { histories, onClose, onSelectHistory, onClearHistory } = this.props

    return (
      <div className='planner-searchhistory'>
        <div className='searchheader'>
          <span className='type'>
            <IntlMessage ident='plannerv2.common.recentSearches' />
          </span>
          <IconButton
            className='fieldaction'
            icon='x'
            type='default'
            size='small'
            onClick={onClose}
          />
          <input
            type='text'
            autoFocus
            className='historyinput'
            onBlur={this._onBlurInput.bind(this)}
          />
        </div>
        {histories.length > 0 ? (
          <>
            <div className='searchlist'>
              {histories.map((history, hIdx) => (
                <div
                  className='searchitem'
                  key={hIdx}
                  onClick={ev =>
                    onSelectHistory && onSelectHistory(history, ev)}
                >
                  {history.keyword && (
                    <div className='filter' key='keyword'>
                      <span className='type'>{history.keyword}</span>
                    </div>
                  )}
                  {history.filters.map((filter, fIdx) => (
                    <div className='filter' key={fIdx}>
                      <span className='type'>{filter.ident}:</span>
                      <span className='text'>{filter.text}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className='searchfooter' onClick={onClearHistory}>
              <span className='type'>
                <IntlMessage ident='plannerv2.common.clearRecentSearches' />
              </span>
              <IconButton
                className='resetaction'
                icon='search-clear'
                iconSize='14'
              />
            </div>
          </>
        ) : (
          <div className='searchmessage'>
            <span className='type'>
              <IntlMessage ident='plannerv2.common.noSearchMessages' />
            </span>
          </div>
        )}
      </div>
    )
  }

  _onBlurInput (_ev) {
    window.setTimeout(() => {
      if (this.props.onClose) {
        this.props.onClose()
      }
    }, 500)
  }
}

export default PlannerSearchHistory
